import { useState } from 'react';
import styles from 'styles/modules/subscription/Subscription.module.scss';

import Product from './Product';
import Toggle from './Toggle';

const Stripe = ({ products, plan, buttons, discount }) => {
    const [index, setIndex] = useState(0);

    return (
        <>
            {(!plan?.type || plan.type === 'free') && (
                <Toggle {...{ index, setIndex }} />
            )}
            <div className={styles.cardWrapper}>
                {products.map((product) => (
                    <Product
                        key={product.id}
                        {...{ product, buttons, plan, index, discount }}
                    />
                ))}
            </div>
        </>
    );
};

export default Stripe;
